import { render, staticRenderFns } from "./BonusMulti.vue?vue&type=template&id=2695a1d4&"
import script from "./BonusMulti.vue?vue&type=script&lang=js&"
export * from "./BonusMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports